<section class="beauty-workflow section-padding">
    <div class="container">

        <div class="row justify-content-center text-center">
            <div class="col-lg-9">

                <span class="section-badge">
                    {{ 'beautyWorkflow.eyebrow' | translate }}
                </span>

                <h2 class="section-title">
                    {{ 'beautyWorkflow.title' | translate }}
                </h2>

                <p class="section-subtitle">
                    {{ 'beautyWorkflow.subtitle' | translate }}
                </p>

            </div>
        </div>

        <div class="row g-4 mt-4">

            <div class="col-md-4">
                <div class="beauty-workflow-card h-100">

                    <div class="beauty-workflow-icon">
                        <i class="fas fa-calendar-check" aria-hidden="true"></i>
                    </div>

                    <span class="beauty-workflow-step">
                        {{ 'beautyWorkflow.step1Label' | translate }}
                    </span>

                    <h3>
                        {{ 'beautyWorkflow.step1Title' | translate }}
                    </h3>

                    <p>
                        {{ 'beautyWorkflow.step1Text' | translate }}
                    </p>

                </div>
            </div>

            <div class="col-md-4">
                <div class="beauty-workflow-card h-100">

                    <div class="beauty-workflow-icon">
                        <i class="fas fa-spa" aria-hidden="true"></i>
                    </div>

                    <span class="beauty-workflow-step">
                        {{ 'beautyWorkflow.step2Label' | translate }}
                    </span>

                    <h3>
                        {{ 'beautyWorkflow.step2Title' | translate }}
                    </h3>

                    <p>
                        {{ 'beautyWorkflow.step2Text' | translate }}
                    </p>

                </div>
            </div>

            <div class="col-md-4">
                <div class="beauty-workflow-card h-100">

                    <div class="beauty-workflow-icon">
                        <i class="fas fa-users" aria-hidden="true"></i>
                    </div>

                    <span class="beauty-workflow-step">
                        {{ 'beautyWorkflow.step3Label' | translate }}
                    </span>

                    <h3>
                        {{ 'beautyWorkflow.step3Title' | translate }}
                    </h3>

                    <p>
                        {{ 'beautyWorkflow.step3Text' | translate }}
                    </p>

                </div>
            </div>

        </div>
    </div>
</section>